import { render, staticRenderFns } from "./PreferredDealer.vue?vue&type=template&id=99adb6cc&scoped=true"
import script from "./PreferredDealer.vue?vue&type=script&lang=js"
export * from "./PreferredDealer.vue?vue&type=script&lang=js"
import style0 from "./PreferredDealer.vue?vue&type=style&index=0&id=99adb6cc&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99adb6cc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\Generac.Application.MobileLink\\ClientApp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('99adb6cc')) {
      api.createRecord('99adb6cc', component.options)
    } else {
      api.reload('99adb6cc', component.options)
    }
    module.hot.accept("./PreferredDealer.vue?vue&type=template&id=99adb6cc&scoped=true", function () {
      api.rerender('99adb6cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ApparatusDetails/PreferredDealer.vue"
export default component.exports